import React from 'react';
import Lottie from "lottie-react";
import chain from "../LoadingSvg/blockchain1.json";

const BlockChain = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // height: "80svh",
            }}
        >
            <Lottie
                animationData={chain}
                loop={true}
                style={{ width: "300px", height: "300px" }}
                className='svges'
            />
        </div>
    )
}


export default BlockChain